import { Button } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { Otp } from 'BreetComponents';
import { useOtpApi } from 'BreetHooks';
import { useCallback } from 'react';

import type { IOTPForm } from './OTP/helpers';

const OtpForm = ({
	className,
	errorMessage,
	onSubmit,
	otpLength,
	isLoading,
	resendOtpLoading,
	onChange,
	onResend,
	buttonTitle,
	value,
	position = 'center',
	resendOtp = true,
	hideButton = false,
	cta,
}: IOTPForm) => {
	const { otpRef, resetOtpInputValues } = useOtpApi();

	const handleResend = useCallback(
		(restartCountDown?: () => void) => {
			onResend?.(restartCountDown);
			resetOtpInputValues();
		},
		[onResend, resetOtpInputValues]
	);

	const showResend = !!(onResend && resendOtp) || !!cta;

	return (
		<form
			className={className}
			onSubmit={onSubmit}
			data-testid='otp-form'
		>
			<Otp.Input
				otpLength={otpLength}
				onChange={onChange}
				error={errorMessage}
				showError={!showResend}
				position={position}
				maskInputValue
				ref={otpRef}
				data-testid='otp-input'
			/>

			{showResend && (
				<Otp.Resend
					// The resend spinner must reflect ONLY the resend action — not the verify/submit loading
					// (`isLoading`), which is what made it read "Resending…" while the OTP was being verified.
					isLoading={resendOtpLoading}
					onResend={handleResend}
					errorMessage={errorMessage}
					position={position}
					cta={cta}
				/>
			)}

			{!hideButton && (
				<Button
					label={buttonTitle ?? 'Continue'}
					disabled={!!errorMessage || (value?.length ?? 0) < otpLength}
					isLoading={isLoading}
					className={classNameMerger('primary-hover', (!resendOtp || !onResend) && 'reset-otp-btn')}
					type='submit'
				/>
			)}
		</form>
	);
};

export default OtpForm;
